var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-form-container",
    { attrs: { disabled: _vm.disabled } },
    [
      _c(
        "a-tabs",
        { attrs: { "default-active-key": "1" }, on: { change: _vm.tabChange } },
        [
          _c("a-tab-pane", {
            key: "1",
            attrs: { tab: "BU層級資訊", forceRender: true }
          }),
          _c("a-tab-pane", {
            key: "2",
            attrs: { tab: "PC層級資訊", forceRender: true }
          }),
          _c("a-tab-pane", {
            key: "3",
            attrs: { tab: "法人資訊", forceRender: true }
          })
        ],
        1
      ),
      _c("a-table", {
        ref: "table",
        staticClass: "j-table-force-nowrap",
        attrs: {
          size: "middle",
          scroll: { x: true },
          bordered: "",
          rowKey: "id",
          columns: _vm.columns,
          dataSource: _vm.dataSource,
          pagination: false,
          loading: _vm.loading
        },
        on: { change: _vm.handleTableChange }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }